export default __webpack_public_path__ + "static/media/sider-background.1a32a563.svg";